import { CancelToken } from "axios";
import apiClient from "../utils/apiClient";
import { BlobSasRequestDto } from "../types/FolderPermission";

interface DownloadFolderConfig {
  responseType: "blob";
  cancelToken: CancelToken;
}

export interface DownloadFileConfig {
  responseType: "blob";
}

export const downloadZip = async (
  config: DownloadFolderConfig,
  userId: number,
  folderId: number
) => {
  const response = await apiClient.get(`/portal/download/stream-zip/${userId}/${folderId}`, config);
  return response.data;
};

export const downloadFile = async (config: DownloadFileConfig, blobName: string) => {
  const response = await apiClient.get(`/portal/download/file/${blobName}`, config);
  return response.data;
};

export const getBlobSasUri = async (requestDto: BlobSasRequestDto) => {
  const response = await apiClient.get(
    `/portal/download/blobSasUri/${requestDto.BlobName}/${requestDto.FileName}`
  );
  return response.data;
};

export const downloadStart = async (userId: number, folderId: number) => {
  const response = await apiClient.post(`/portal/download/start`, {
    userId,
    folderId,
  });
  return response;
};
